export default (fullQuery: string) => {
  try {
    return fullQuery.split('@media ')[1];
  } catch (e) {
    return '';
  }
};
